module.exports = __webpack_public_path__ + "img/foundation-baner.72be4c99.png";